import translation from 'translation';

export function getPages() {
  const { t } = translation;

  return [
    {
      path: '/contents/*',
      steps: [
        {
          title: t('academy:contents'),
          videoSrc:
            'https://www.aparat.com/video/video/embed/videohash/p6g1D/vt/frame?recom=self',
        },
      ],
    },
    {
      path: '/subjects/*',
      steps: [
        {
          title: t('academy:advancedSubjectCreator'),
          videoSrc:
            'https://www.aparat.com/video/video/embed/videohash/o2Sae/vt/frame?recom=self',
          text: t('layout:quickGuide.subjects.addSubjectGuide'),
        },
      ],
    },
    {
      path: '/support/*',
      steps: [
        {
          title: t('academy:ticketing'),
          videoSrc:
            'https://www.aparat.com/video/video/embed/videohash/WaYhu/vt/frame?recom=self',
        },
      ],
    },
    {
      path: '/statistics/*',
      steps: [
        {
          title: t('statistics:pageTitle'),
          videoSrc:
            'https://www.aparat.com/video/video/embed/videohash/rvdy3iz/vt/frame?recom=self',
        },
      ],
    },
    {
      path: '/bulletins/*',
      steps: [
        {
          title: t('academy:autoBulletinCreator'),
          videoSrc:
            'https://www.aparat.com/video/video/embed/videohash/ElPO2/vt/frame?recom=self',
        },
      ],
    },
    {
      path: '*',
      steps: [
        {
          text: t('support:usingAdvancedFiltersGetResultsFaster'),
        },
      ],
    },
  ];
}
